import { render, staticRenderFns } from "./FileEditor.vue?vue&type=template&id=2b974385&scoped=true"
import script from "./FileEditor.vue?vue&type=script&lang=js"
export * from "./FileEditor.vue?vue&type=script&lang=js"
import style0 from "./FileEditor.vue?vue&type=style&index=0&id=2b974385&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b974385",
  null
  
)

export default component.exports